<template>
  <v-col sm="2" lg="1" class="pt-0 text-center">
    <i class="icon-zoom color-11" @click="show()"></i>
    <div id="ContBtnZoom" class="sliderFloat">
      <div id="slide" class="slidecontainer">
        <i @click="less()" class="font-less color-11"></i>
        <input
          type="range"
          :min="minZoom"
          :max="maxZoom"
          v-model="$store.state.escala"
          step="0.01"
          class="slider"
          id="rangeZoom"
        />
        <i @click="plus()" class="font-plus color-11"></i>
      </div>
    </div>
  </v-col>
</template>

<script>
import $ from "jquery";

export default {
  name: "Zoom",

  data: () => ({
    showZoom: false,
    maxZoom: 5,
    minZoom: 1
  }),
  methods: {

    //Muestra el slidebar
    show() {
      if (!this.showZoom) {
        $("#ContBtnZoom").css("visibility", "visible");
        this.showZoom = true;
      } else {
        $("#ContBtnZoom").css("visibility", "hidden");
        this.showZoom = false;
      }
    },

    //Disminuye el ZOOM
    less() {
      this.$store.state.escala -= 0.1;
      if (this.$store.state.escala >= this.minZoom) {
        $("#pageLM").css(
          "transform",
          "scale3d(" + this.$store.state.escala + "," + this.$store.state.escala + ",1)"
        );
      } else {
        this.$store.state.escala = this.minZoom;
      }
    },

    //Aumenta el ZOOM
    plus() {
      this.$store.state.escala += 0.1;
      if (this.$store.state.escala <= this.maxZoom) {
        $("#pageLM").css(
          "transform",
          "scale3d(" + this.$store.state.escala + "," + this.$store.state.escala + ",1)"
        );
      } else {
        this.$store.state.escala = this.maxZoom;
      }
    }
  },
  updated: function() {
    this.$store.state.escala = parseFloat($("#rangeZoom").val());//El valor del input range se convierte en float

    //Se escala las paginas
    $("#pageLM").css(
      "transform",
      "scale3d(" + this.$store.state.escala + "," + this.$store.state.escala + ",1)"
    );

    //Si el valor del zoom es 1, entonces se regresa a su escala original
    if (this.$store.state.escala > 1) {

      //Se agrega la clase 'draggable' para poder mover las paginas
      $('#viewer').addClass('draggable');
    } else{
      $('#viewer').removeClass('draggable');
      $("#pageLM").css({top: '0px', left: '0px'});
    }
  },
  mounted: function() {
    //Se emplea las siguientes funciones para que se pueda mover las paginas con el mouse
    var pointer = function(event) {
      try {
        var canvas = document.getElementsByTagName("canvas")[0],
          rect = canvas.getBoundingClientRect();
        return {
          x:
            ((event.pageX - rect.left) / (rect.right - rect.left)) *
            canvas.width,
          y:
            ((event.pageY - rect.top) / (rect.bottom - rect.top)) *
            canvas.height
        };
      } catch (err) {
        return { x: 0, y: 0 };
      }
    };
    
    var updateScrollPos = function(e) {
      var viewer = document.querySelector("ul#viewer"),
        $viewer = $(viewer),
        point = pointer(e),
        diffY = click.y - point.y,
        diffX = click.x - point.x;
      //Si #viewer tiene la clase 'draggable' se podrá mover las paginas
      if ($viewer.hasClass("draggable") && e.target.localName == 'canvas' || e.target.id == 'viewer' 
          || e.target.localName == 'article' || e.target.localName == 'aside' || e.target.id == 'pageOne' || e.target.id == 'pageTwo') {
        var pag = $("#viewer li");
        
        pag[0].style.left = parseFloat(pag[0].style.left || 0) - diffX + "px";
        pag[0].style.top = parseFloat(pag[0].style.top || 0) - diffY + "px";
      }
    };

    var clicked = false;
    var click;

    $(document).on({
      mousemove: function(e) {
        if (!$(document.body).hasClass("kinetic") && $('#viewer').hasClass('draggable')) {
          clicked && updateScrollPos(e);
        }
      },
      mousedown: function(e) {
        if (!$(document.body).hasClass("kinetic") && $('#viewer').hasClass('draggable')) {
          clicked = true;
          click = pointer(e);
          $("#viewer").css("cursor", "pointer");
        }
      },
      "mouseup mouseout": function(e) {
        if (!$(document.body).hasClass("kinetic") && $('#viewer').hasClass('draggable')) {
          clicked = false;
          $("#viewer").css("cursor", "auto");
        }
      }
    });
  }
};
</script>